module.exports = __webpack_public_path__ + "static/media/image20.11b5c9df.png";